module.exports = __webpack_public_path__ + "static/media/parent.6c1c3ad0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/parent-agreement/views/main-record/images/parent.svg
// module id = 1142
// module chunks = 0